
import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {useFormik} from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import CardHeader from "@material-ui/core/CardHeader";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import { createNewTruck, updateTruck } from "../AdminPagesCrud";

function TruckAddEdit({truck, setTruck, supplierId, edit, setEdit, isNew, setIsNew, intl}){

    // const {id} = useParams();

    const {accessToken} = useSelector (
        ({auth}) =>({
            accessToken: auth.authToken,
        })
    )

    useEffect(() => {

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const truckSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(30, "Maximum 30 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        avgCases: Yup.number()
            .min(1, "minimum 1 case")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const formik = useFormik({
        initialValues: truck,
        validationSchema: truckSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            try {
                if(isNew){

                    createNewTruck(values, supplierId, accessToken).then((response) => {
                        setIsNew(!isNew)
                        setTruck({ 
                            name : "",
                            avgCases: 0 
                        })
                        // setShowSnackbar(!showSnackbar)
                    })
                }
                else {
                    updateTruck(truck._id, values, accessToken).then((response) => {
                        setEdit(!edit)
                        setTruck({ 
                            name : "",
                            avgCases: 0 
                        })
                    })
                }

            } catch (e) {
                alert("An error occurred");
                console.log(e.message);
            }
        },
    });


    return (
        <>
            <Card>
                {edit ? <CardHeader title="Edit Truck"/> : <CardHeader title="New Truck"/> }
                <CardBody>
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div className="">
                                <div className="col-12">
                                    <Grid container>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Truck Name</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="name"
                                                        {...formik.getFieldProps("name")}
                                                    />
                                                    {formik.touched.name && formik.errors.name ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.name}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Average cases per truck</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="avgCases"
                                                        {...formik.getFieldProps("avgCases")}
                                                    />
                                                    {formik.touched.name && formik.errors.avgCases ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.avgCases}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                                { edit ?
                                    <div className="col-12 row justify-content-center">
                                    
                                        <button className="btn btn-primary" type="submit">
                                            Save
                                        </button>
                                        <div className="pl-4"/>
                                        <button className="btn btn-secondary" type="button" onClick={() => {
                                                setTruck({ name : "", avgCases: 0 })
                                                setEdit(!edit)
                                            }
                                        }>
                                            Cancel
                                        </button>
                                    </div>
                                    :
                                    <div className="col-12 row justify-content-center">
                                    
                                        <button className="btn btn-primary" type="submit">
                                            Create
                                        </button>
                                        <div className="pl-4"/>
                                        <button className="btn btn-secondary" type="button" onClick={() => {
                                                setTruck({ name : "", avgCases: 0 })
                                                setIsNew(!isNew)
                                            }
                                        }>
                                            Cancel
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </>
    )
}

export default injectIntl(TruckAddEdit);
